import React from 'react';
import format from 'react-format-props';
import { result, isNil } from 'lodash';
import propTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { howLongAgo } from '@fiverr-private/futile/lib/datetime';
import { Icon, Tooltip } from '@fiverr-private/fit';
import {
    s_circle,
    s_times_circle,
    s_circle_arrow_right,
    r_exclamation_triangle,
    l_circle_with_dot,
    s_check_circle,
    r_block_user,
    r_hourglass,
} from '@fiverr-private/fit/icons';
import classes from './index.module.scss';

export function ItemFooter({ dateTime, subCategory, status }, { locale }) {
    const longAgo = howLongAgo(dateTime, { prefix: 'realtime_notifications.notifications_drawer.long_ago.', locale });

    return (
        <footer className={classes.itemMeta}>
            {dateTime && (
                <>
                    <time dateTime={dateTime}>{longAgo}</time>
                    <Spacer />
                </>
            )}
            {subCategory && (
                <>
                    <span className={classes.subCategory}>{subCategory}</span>
                    <Spacer />
                </>
            )}
            {status && (
                <Tooltip
                    content={<I18n k={`realtime_notifications.notifications_drawer.status.${getStatusKey(status)}`} />}
                    containerClassName={classes.tooltip}
                    boxContentClassName={classes.status}
                    position={Tooltip.POSITIONS.LEFT}
                >
                    <Icon size={10} className={classes.icnStatus}>
                        {getIcon(status)}
                    </Icon>
                </Tooltip>
            )}
        </footer>
    );
}

function Spacer() {
    return (
        <Icon size={2} className={classes.spacer}>
            {s_circle}
        </Icon>
    );
}

function getStatusKey(status) {
    if (isNil(status)) {
        return status;
    }

    return status.split('-').join('_');
}

function getIcon(status) {
    switch (status) {
        case 'rejected':
            return s_times_circle;
        case 'delivered':
            return s_circle_arrow_right;
        case 'late':
            return r_exclamation_triangle;
        case 'new':
            return l_circle_with_dot;
        case 'completed':
            return s_check_circle;
        case 'cancelled':
            return r_block_user;
        case 'in-progress':
            return r_hourglass;
        default:
            return null;
    }
}

const resolveSubCategory = (item) => result(item, 'msg_params.sub_category');
const resolveStatus = (item) => result(item, 'msg_params.order_status');

ItemFooter.propTypes = {
    dateTime: propTypes.number,
    subCategory: propTypes.string,
    status: propTypes.string,
};

ItemFooter.contextTypes = {
    locale: propTypes.string,
};

export default format(({ item }) => ({
    dateTime: (item.recent_message_date || item.updated_at || 0) * 1000,
    subCategory: resolveSubCategory(item),
    status: resolveStatus(item),
}))(ItemFooter);
